import { Box, Button, Typography } from "@mui/material"

import IconBox from "../../IconBox"
import ModalBox from "../../ModalBox"
import { BankText, CloseButton, SourceDescription } from "./styled"
import UIIcon from "../../UIIcon"
import { BoxModal } from "../styled"

const ErrorHandlerModal = ({
  open,
  toggleMOdal,
}: {
  open: boolean
  toggleMOdal: () => void
}) => (
  <ModalBox open={open} onClose={toggleMOdal}>
    <Box sx={BoxModal}>
      <IconBox size="lg" color="yellow">
        <UIIcon iconName="globalErrorIcon" size={80} />
      </IconBox>
      <SourceDescription variant="h3">Ошибка сервиса</SourceDescription>
      <Typography sx={BankText}>
        Произошла ошибка сервиса. Повторите попытку позже.
      </Typography>
      <Button variant="contained" sx={CloseButton} onClick={toggleMOdal}>
        Продолжить
      </Button>
    </Box>
  </ModalBox>
)

export default ErrorHandlerModal
